import { useQuery } from "@tanstack/react-query";
import { fetchMe } from "@/api/me";

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: ({ signal }) => fetchMe(signal),
  });
}
